import { FC } from 'react';
import { Button } from 'antd';
import { PERMISSION_ROUTES, PERMISSION_ACTIONS } from 'constants/permissions';

import { Private } from 'components/shared';
import { PageWrapper } from 'components/ui';

const Services: FC = () => {
  return (
    <PageWrapper
      title="Services"
      color="white"
      extra={[
        <Private
          key="faq"
          route={PERMISSION_ROUTES.super}
          action={PERMISSION_ACTIONS.update}
        >
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Private>
      ]}
    >
      <Button>Create</Button>
    </PageWrapper>
  );
};

export default Services;
